<template>
  <sdf-busy-indicator v-bind="$props"></sdf-busy-indicator>
</template>

<script setup lang="ts">
import type { JSX } from '@waypoint/web-components';

defineOptions({
  name: 'SdfBusyIndicator',
});

defineProps<Partial<JSX.SdfBusyIndicator>>();
</script>
